/**
 * Multirow Read More Functionality
 * Handles mobile text truncation and Read More/Less toggle
 * Only active on mobile devices (767px and below)
 */

class MultirowReadMore {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupReadMore());
    } else {
      this.setupReadMore();
    }
  }

  setupReadMore() {
    const readMoreButtons = document.querySelectorAll('.read-more-btn');
    
    if (readMoreButtons.length === 0) return;

    readMoreButtons.forEach(button => this.bindButtonEvents(button));
  }

  bindButtonEvents(button) {
    // Get custom text values from data attributes
    const originalText = button.textContent.trim();
    const readLessText = button.getAttribute('data-read-less-text') || 'Read Less';
    
    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleReadMore(button, originalText, readLessText);
    });
  }

  toggleReadMore(button, originalText, readLessText) {
    const container = button.closest('.text-content-mobile');
    
    if (!container) return;
    
    const truncatedText = container.querySelector('.text-truncated');
    const fullText = container.querySelector('.text-full');
    
    if (!truncatedText || !fullText) return;

    const isExpanded = truncatedText.style.display === 'none';
    
    if (!isExpanded) {
      // Show full text
      truncatedText.style.display = 'none';
      fullText.classList.remove('tw-hidden');
      button.textContent = readLessText;
      button.setAttribute('aria-expanded', 'true');
    } else {
      // Show truncated text
      truncatedText.style.display = 'block';
      fullText.classList.add('tw-hidden');
      button.textContent = originalText;
      button.setAttribute('aria-expanded', 'false');
    }
  }

  // Method to reinitialize if content is dynamically added
  refresh() {
    this.setupReadMore();
  }
}

// Initialize the Read More functionality
const multirowReadMore = new MultirowReadMore();

// Make it globally accessible for dynamic content
window.MultirowReadMore = MultirowReadMore;
window.multirowReadMore = multirowReadMore; 